/**
 * @generated SignedSource<<04e941300ae8c77dcc451e7ff06919c8>>
 * @relayHash 9fd7422f0bc569cb2c719b2629db4eb6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f60c507e36685af78bec6797f267735504a29ac0dd19c3d5162a4a692a2589df

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

import isICCHarmonisationBacklogEnabled_provider from '@atlassian/jira-relay-provider/src/icc-harmonisation-backlog.relayprovider';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f60c507e36685af78bec6797f267735504a29ac0dd19c3d5162a4a692a2589df",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrciccharmonisationbacklogrelayprovider": isICCHarmonisationBacklogEnabled_provider
    }
  }
};

export default node;
